const LOCKED_KEY = "credora_session_locked";
const LAST_ACTIVITY_KEY = "credora_session_last_activity";

export function isSessionLockPersisted() {
  try {
    return sessionStorage.getItem(LOCKED_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistSessionLocked() {
  try {
    sessionStorage.setItem(LOCKED_KEY, "1");
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearSessionLocked() {
  try {
    sessionStorage.removeItem(LOCKED_KEY);
  } catch {
    /* ignore */
  }
}

export function getLastActivity() {
  try {
    const raw = sessionStorage.getItem(LAST_ACTIVITY_KEY);
    if (!raw) {
      return null;
    }
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

export function setLastActivity(timestamp = Date.now()) {
  try {
    sessionStorage.setItem(LAST_ACTIVITY_KEY, String(timestamp));
  } catch {
    /* ignore */
  }
}

export function clearSessionLockStorage() {
  clearSessionLocked();
  try {
    sessionStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    /* ignore */
  }
}
